import { formatToCurrency } from '@utils/currency/formatToCurrency';
import { formatToFullWithCurrencyPreset } from '@utils/currency/formatToFullWithCurrencyPreset';

import { CLP } from '@/types/currency';

import { type CurrencyProps } from './types';

const Currency = ({
  fallbackValue,
  children: value,
  emptyValue,
  format = 'full',
  currency = CLP,
}: CurrencyProps) => {
  if (value === '' || value === null || value === undefined) return emptyValue;

  const numberValue = Number(value);

  if (isNaN(numberValue)) return fallbackValue;

  return currency === CLP
    ? formatToCurrency(numberValue, format)
    : formatToFullWithCurrencyPreset(numberValue, currency);
};

export { Currency };
